import { OverlayContainer } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RtOverlayContainer extends OverlayContainer {
  private readonly CDK_CONTAINER_CLASS = 'cdk-overlay-container';
  private readonly RT_CONTAINER_CLASS = 'rt-overlay-container';

  public getContainerElement(): HTMLElement {
    const container = super.getContainerElement();
    if (container.classList.contains(this.CDK_CONTAINER_CLASS)) {
      container.classList.remove(this.CDK_CONTAINER_CLASS);
      container.classList.add(this.RT_CONTAINER_CLASS);
    }
    return container;
  }
}
